// extracted by mini-css-extract-plugin
export var section = "PageSectionHalfBleed-module--section--1sdmg";
export var container = "PageSectionHalfBleed-module--container--26C7Y";
export var column = "PageSectionHalfBleed-module--column--39jQy";
export var column2 = "PageSectionHalfBleed-module--column2--37QKy";
export var imgWrap = "PageSectionHalfBleed-module--img-wrap--3jkAV";
export var content = "PageSectionHalfBleed-module--content--2roTo";